/* Vitavien Geri Bildirim Formu — feedback.js
   Akış: mood → categories → message → contact → thanks
   "Memnun kaldım" seçilince categories+message atlanıp doğrudan thanks (Google CTA ile)
*/
(function () {
  'use strict';

  const CFG = window.VITAVIEN_FEEDBACK || {};
  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  document.body.classList.add('vfb-active');

  // URL'den branch + receipt_id'yi al.
  // Yeni jenerik URL: /pages/feedback?branch=sisli&receipt=N  (Clopos {receipt_id} placeholder buraya iner)
  // Eski URL: /pages/sisli-feedback?receipt=N  (backwards-compat — path'ten branch çekilir)
  // Fallback: 'sisli' (ilk Clopos şubesi)
  const params = new URLSearchParams(window.location.search);
  const receiptId = params.get('receipt') || params.get('receipt_id') || '';
  const branch = params.get('branch')
    || (window.location.pathname.match(/pages\/([^-]+)-feedback/) || [])[1]
    || 'sisli';

  // Meta etiketi (üstte ufak bilgi)
  const metaEl = $('[data-vfb-meta]');
  if (metaEl) {
    metaEl.textContent = receiptId
      ? `Hesap #${receiptId}`
      : 'Geri bildirim';
  }

  // === STATE ===
  const state = {
    mood: null,
    categories: new Set(),
    message: '',
    contact_name: '',
    contact_phone: '',
    anonymous: false,
    history: ['mood']
  };

  function go(target, push = true) {
    $$('.vfb-screen').forEach(s => {
      const isTarget = s.dataset.vfbScreen === target;
      s.hidden = !isTarget;
      s.classList.toggle('active', isTarget);
    });
    if (push) state.history.push(target);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function back() {
    if (state.history.length <= 1) return;
    state.history.pop();
    const prev = state.history[state.history.length - 1];
    go(prev, false);
  }

  // === Ekran 1 — mood ===
  $$('[data-mood]').forEach(btn => {
    btn.addEventListener('click', () => {
      state.mood = btn.dataset.mood;
      $$('[data-mood]').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');

      if (state.mood === 'positive') {
        // Memnun kaldıysa: kategori/detay atla, doğrudan teşekkür + Google CTA
        showThanks(true);
        // Apps Script'e de yine kaydet (memnuniyet özetinde sayılsın)
        submitFeedback({ silent: true });
      } else {
        setTimeout(() => go('categories'), 200);
      }
    });
  });

  // === Ekran 2 — categories ===
  $$('[data-cat]').forEach(btn => {
    btn.addEventListener('click', () => {
      const cat = btn.dataset.cat;
      if (state.categories.has(cat)) {
        state.categories.delete(cat);
        btn.classList.remove('selected');
      } else {
        state.categories.add(cat);
        btn.classList.add('selected');
      }
    });
  });

  $('[data-vfb-next-cat]').addEventListener('click', () => go('message'));

  // === Ekran 3 — message ===
  const ta = $('[data-vfb-message]');
  const counter = $('[data-vfb-counter]');
  ta.addEventListener('input', () => {
    state.message = ta.value;
    if (counter) counter.textContent = ta.value.length;
  });

  $('[data-vfb-next-msg]').addEventListener('click', () => go('contact'));

  $('[data-vfb-skip]').addEventListener('click', () => {
    state.message = '';
    ta.value = '';
    go('contact');
  });

  // === Ekran 4 — contact ===
  $('[data-vfb-anon]').addEventListener('change', (e) => {
    state.anonymous = e.target.checked;
    $('[data-vfb-name]').disabled = state.anonymous;
    $('[data-vfb-contact]').disabled = state.anonymous;
    if (state.anonymous) {
      $('[data-vfb-name]').value = '';
      $('[data-vfb-contact]').value = '';
    }
  });

  $('[data-vfb-submit]').addEventListener('click', async () => {
    state.contact_name = $('[data-vfb-name]').value.trim();
    state.contact_phone = $('[data-vfb-contact]').value.trim();

    const ok = await submitFeedback();
    if (ok) showThanks(state.mood === 'positive');
  });

  // === BACK butonları ===
  $$('[data-vfb-back]').forEach(b => b.addEventListener('click', back));

  // === Submit ===
  async function submitFeedback(opts) {
    opts = opts || {};
    const loading = $('[data-vfb-loading]');
    if (!opts.silent && loading) loading.hidden = false;

    const fingerprint = await getFingerprint();

    const payload = {
      receipt_id: receiptId,
      branch: branch,
      mood: state.mood,
      categories: Array.from(state.categories),
      message: state.message,
      contact_name: state.contact_name,
      contact_phone: state.contact_phone,
      anonymous: state.anonymous,
      fingerprint: fingerprint
    };

    try {
      // Cloudflare Workers /feedback_submit — JSON POST + CORS açık (panel.v9 migration).
      const workersUrl = CFG.WORKERS_URL || CFG.APPS_SCRIPT_URL;
      const url = workersUrl + '/feedback_submit';
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const data = await res.json();
      if (loading) loading.hidden = true;

      if (!data.ok && !opts.silent) {
        if (data.error === 'duplicate') {
          alert('Bu hesap için zaten geri bildirim aldık, teşekkürler.');
        } else {
          alert('Gönderim başarısız: ' + (data.error || 'unknown') + '. Lütfen tekrar deneyin.');
        }
        return false;
      }
      return true;
    } catch (e) {
      if (loading) loading.hidden = true;
      if (!opts.silent) alert('Gönderim sırasında bir sorun oldu. İnternet bağlantınızı kontrol edip tekrar deneyin.');
      return false;
    }
  }

  function showThanks(positive) {
    go('thanks');
    if (positive) {
      const cta = $('[data-vfb-google-cta]');
      const link = $('[data-vfb-google-link]');
      const title = $('[data-vfb-thanks-title]');
      const sub = $('[data-vfb-thanks-sub]');
      if (title) title.textContent = 'Sevindirdiniz, teşekkürler.';
      if (sub) sub.textContent = 'Vitavien için anlamlı bir gündü.';
      if (cta && CFG.GOOGLE_REVIEWS_URL) {
        cta.hidden = false;
        if (link) link.href = CFG.GOOGLE_REVIEWS_URL;
      }
    }
  }

  async function getFingerprint() {
    // Çok hafif fingerprint — tarayıcı + ekran + dil
    const raw = `${navigator.userAgent}|${navigator.language}|${screen.width}x${screen.height}|${new Date().getTimezoneOffset()}`;
    const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(raw));
    return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, '0')).join('').substring(0, 32);
  }
})();
